import { useEffect, useState } from 'react';

export const UnrealPressFlash = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const showFlash = () => {
      setIsVisible(true);
      // Flash stays visible for 300ms
      setTimeout(() => {
        setIsVisible(false);
      }, 300);
    };

    // First flash after random delay (5-15 seconds)
    const initialDelay = Math.random() * 10000 + 5000;
    const initialTimer = setTimeout(showFlash, initialDelay);

    // Then flash at random intervals (15-45 seconds)
    const intervalId = setInterval(() => {
      const randomDelay = Math.random() * 30000 + 15000;
      setTimeout(showFlash, randomDelay);
    }, 45000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalId);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] pointer-events-none flex items-center justify-center">
      <div className="relative text-center">
        <h1 
          className="text-[12rem] md:text-[16rem] lg:text-[20rem] font-bold text-white tracking-tighter leading-none animate-pulse"
          style={{
            textShadow: '0 0 40px rgba(255, 255, 255, 0.8), 0 0 80px rgba(255, 255, 255, 0.6)',
            mixBlendMode: 'screen'
          }}
        >
          UNREAL
        </h1>
        <h2 
          className="text-[12rem] md:text-[16rem] lg:text-[20rem] font-bold text-white tracking-tighter leading-none"
          style={{
            textShadow: '0 0 40px rgba(255, 255, 255, 0.8), 0 0 80px rgba(255, 255, 255, 0.6)',
            mixBlendMode: 'screen'
          }}
        >
          PRESS
        </h2>
      </div>
    </div>
  );
};
